const MODULES = ['Scheduling', 'Summarization', 'PII Redaction', 'Intent Extraction'];

export const aiPolicyList = Array.from({ length: 8 }, (_, i) => ({
  id: `aip-${i}`,
  name: [
    'Scheduler intent',
    'Executive summary',
    'PII redaction strict',
    'Intent extraction v2',
    'Token budget cap',
    'Locale routing',
    'Fallback summarization',
    'Action item extraction',
  ][i],
  module: MODULES[i % 4],
  modelRoute: i % 2 === 0 ? 'gpt-4o → mini' : 'claude-3.5 → gpt-4o-mini',
  threshold: `${0.75 + (i % 4) * 0.05}`,
  scopeType: ['default', 'plan', 'tenant'][i % 3],
  scopeLabel: ['Default', 'Plan: Enterprise', 'Tenant: T-204', 'Plan: Growth', 'Default', 'Tenant: T-118', 'Default', 'Plan: Starter'][i],
  status: i === 5 ? 'disabled' : 'active',
  activeTenantRefs: i === 5 ? 3 : 0,
  updatedAt: new Date(Date.now() - i * 86400000 * 2).toISOString(),
}));

export const promptDetailById = Object.fromEntries(
  aiPolicyList.map((p) => [
    p.id,
    {
      ...p,
      systemPrompt: `You are a meeting scheduling assistant for ${p.module}. Extract intent, attendees, date/time, and return structured JSON only.`,
      developerRules:
        'Always return JSON. Never make up attendee emails. Use ISO-8601 for dates. If unsure, set confidence below threshold.',
      examples: [
        {
          id: 'ex-0',
          input: 'Book a 30m with Dana and Lee next Tuesday morning',
          outputJson: JSON.stringify(
            {
              intent: 'book_meeting',
              attendees: ['dana@acme.com', 'lee@acme.com'],
              confidence: 0.94,
            },
            null,
            2
          ),
        },
        {
          id: 'ex-1',
          input: 'Move my 3pm to 4pm tomorrow',
          outputJson: JSON.stringify(
            { intent: 'reschedule', delta: '1h', confidence: 0.88 },
            null,
            2
          ),
        },
      ],
    },
  ])
);

export const modelRoutingGrid = Array.from({ length: 6 }, (_, i) => ({
  id: `mrg-${i}`,
  module: MODULES[i % 4] + (i > 3 ? ` (${i})` : ''),
  primaryModel: i % 2 === 0 ? 'gpt-4o' : 'claude-3-5-sonnet',
  fallbackModel: 'gpt-4o-mini',
  timeoutMs: 12000 + i * 1000,
  tokenLimit: 8000 + i * 500,
  status: i === 2 ? 'pending_approval' : 'active',
  avgLatencyMs: 320 + i * 90,
  estCostUsdPer1k: 0.012 + i * 0.002,
}));
